import { getUserAgentId } from '../shared/helper-utils/localStorage';
import { doPost } from './apiUtils';

export const getRecentCities = async () => {
  const request = {
    opid: 'HS000',
    actioncode: 'POPULARSECTOR',
  };
  const response = await doPost(request);
  return response;
};

export const getCitiesApi = async (searchvalue) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'GETSOURCEV2',
      agentid: getUserAgentId(),
      // responseformat: 'html',
      searchvalue,
    };
    let response = await doPost(request);
    response = Array.isArray(response) ? response : [response];
    return response.filter((cityNode) => cityNode.cityCode !== '');
  } catch (error) {
    return [];
  }
};

export const searchBusesApi = async (req) => {
  try {
    const reqData = {
      ...req,
      agentid: getUserAgentId(),
    };
    const request = {
      opid: 'BS000',
      actioncode: 'SEARCH',
      agentid: getUserAgentId(),
      searchrequest: JSON.stringify(reqData),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusSeatLayoutApi = async (busDetails, searchrequest) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'GETBUSSEATMAP',
      agentid: getUserAgentId(),
      seatrequest: JSON.stringify({
        selectedbus: busDetails,
        searchrequest,
        corporateid: getUserAgentId(),
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusFareApi = async (
  selectedBus,
  searchRequest,
  selectedSeats,
  seatResponseId,
) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'GETFARE',
      agentid: getUserAgentId(),
      busfarerequest: JSON.stringify({
        selectedbus: selectedBus,
        searchrequest: searchRequest,
        selectedseats: selectedSeats,
        seatResponseId,
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const bookBusApi = async (req, agentId) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'BOOKBUS',
      agentid: agentId,
      busbookingrequest: JSON.stringify(req),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusBookingsApi = async (fromDate, toDate) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'BOOKINGHISTORY',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      fromdate: fromDate,
      todate: toDate,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusBookingDetailsApi = async (transactionId) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'BS011',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      txid: transactionId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const cancelBusBookingApi = async (transactionId, busSeats) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'BUSCANCEL',
      agentid: getUserAgentId(),
      txid: transactionId,
      busseats: busSeats,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusCancellationsApi = async (fromDate, toDate) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'GETBUSCANXHISTORY',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      fromdate: fromDate,
      todate: toDate,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBusBookingCancellationDetailsApi = async (transactionId) => {
  try {
    const request = {
      opid: 'BS000',
      actioncode: 'BS012',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      txid: transactionId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getProfileForNameApi = async (name, agentId) => {
  try {
    const request = {
      opid: 'PROFILE003',
      actioncode: 'GETPROFILEFORNAME',
      corporateid: agentId,
      resultformat: 'JSON',
      name,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
